import { Component } from '@angular/core';
import { ObjectLayoutWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-popq-widget',
  templateUrl: './popq.widget.html',
} )
export class POPQWidget extends ObjectLayoutWidget {
  schema: JSONSchema;

  constructor() {
    super();
  }

  get widget() {
    let widget = this.schema.widget;
    return typeof widget === 'string' ? { id: widget } : widget;
  }

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/popq.widget.ts